<template>
    <div>
        <headerNotice routerName="订单列表"></headerNotice>
        <!-- 搜索栏 -->
        <div class="searchBox">
            <el-row :gutter="24">
                <!-- 搜索框 -->
                <el-col :span="5" :offset="0">
                    <el-input placeholder="请输入单号/用户昵称/手机号" v-model="serachForm.keyword">
                        <el-button slot="append" icon="el-icon-search" @click="serachIt"></el-button>
                    </el-input>
                </el-col>
                <!-- 订单状态搜索 -->
                <el-col :span="3" :offset="0">
                    <el-select
                        v-model="serachForm.status"
                        @change="fastOrderStatusSearch"
                        placeholder="请选择单据状态"
                        @value='serachForm.status'
                    >
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="待付款" :value="1"></el-option>
                        <el-option label="待审核" :value="3"></el-option>
                        <el-option label="配货中" :value="4"></el-option>
                        <el-option label="异常" :value="5"></el-option>
                        <el-option label="待发货" :value="7"></el-option>
                        <el-option label="待收货" :value="8"></el-option>
                        <el-option label="已完成" :value="10"></el-option>
                        <el-option label="已关闭" :value="14"></el-option>
                        <el-option label="退款中" :value="13"></el-option>
                    </el-select>
                </el-col>
                <!-- 打印状态搜索 -->
                <el-col :span="3" :offset="0">
                    <el-select
                        v-model="printStatus"
                        @change='printStatusChange'
                        placeholder="请选择打印状态"
                    >
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="快递单未打印" :value="1"></el-option>
                        <el-option label="快递单已打印" :value="2"></el-option>
                        <el-option label="发货单未打印" :value="3"></el-option>   
                        <el-option label="发货单已打印" :value="4"></el-option>
                        <el-option label="全部已打印" :value="5"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4" :offset="0">
                    <el-date-picker
                        @change='durationChange'
                        style='width:240px;'
                        v-model="duration"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-col>
                <el-col :span="4" :offset="0">
                    <el-button type="primary" @click="searchDialog=true">
                        <i class="el-icon-search"></i> 高级搜索
                    </el-button>
                </el-col>

                <!-- <el-col :span="2" :offset="4">
                    <el-button type="primary">
                        <i class="el-icon-refresh"></i> 导出
                    </el-button>
                </el-col> -->
            </el-row>
        </div>
        <!-- 数据表格 -->
        <div class="dataTable" v-loading="loading">
            <!-- 多选操作 -->
            <div style="margin-top: 20px;margin-bottom:20px;">
                <span class="notice" v-if="choosedItem.length">
                    已经选择
                    <i>{{choosedItem.length}}</i> 项
                </span>
                <el-button type="primary" @click="batchAuditOrder">批量审核订单</el-button>
                <el-button type="primary" @click="markupException">批量标记异常</el-button>
                <el-button type="primary" @click="returnNormal">批量转正常</el-button>
                <el-button type="danger" @click="closeOrder">批量关闭订单</el-button>
                <!-- <el-button type="success" @click="ERPSync"><i class="el-icon-refresh"></i> ERP同步</el-button> -->
            </div>
            <el-table
                size='mini'
                :row-style='{"font-size": "14px"}'
                class="tableBox"
                :data="orderList"
                style="width: 100%"
                :default-sort="{prop: 'date', order: 'descending'}"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column align="center" label="单号">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.agent>0">代</el-tag>
                        <span class="orderCode" @click="watchOrderDetail(scope.row)">{{scope.row.orderCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="customer" label="用户昵称"></el-table-column>
                <el-table-column
                    align="center"
                    prop="disAmount"
                    label="订单金额（￥）"
                    width="150"
                    sortable
                ></el-table-column>
                <el-table-column align="center" prop="unit" label="单据状态" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.orderStatus==1" style="color:#f63b3b;">待付款</span>
                        <span v-if="scope.row.orderStatus==3" style="color:#f63b3b;">待审核</span>
                        <span v-if="scope.row.orderStatus==4" style="color:#f63b3b;">配货中</span>
                        <span v-if="scope.row.orderStatus==5" style="color:#f63b3b;">异常订单</span>
                        <span v-if="scope.row.orderStatus==7" style="color:#f63b3b;">待发货</span>
                        <span v-if="scope.row.orderStatus==8" style="color:#f63b3b;">待收货</span>
                        <span v-if="scope.row.orderStatus==10">已完成</span>
                        <span v-if="scope.row.orderStatus==14">已关闭</span>
                        <span v-if="scope.row.orderStatus==13">退款中</span>  
                         <span v-if="scope.row.orderStatus==17" style="color:#f63b3b;">退款成功</span>
                          <span v-if="scope.row.orderStatus==18" style="color:#f63b3b;">退款失败</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="stock" label="财务状态" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.payStatus==1">已付款</span>
                        <span v-else style="color:#f63b3b;">未付款</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="orderPerson" label="制单人" width="100"></el-table-column>
                <el-table-column align="center" prop="payTime" label="提交时间" width="100" sortable></el-table-column>
                <el-table-column align="center" prop="remark" label="订单备注"></el-table-column>
                <el-table-column align="center" label="快递单状态"  width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.expressPrintStatus==0" style="color:#f63b3b;">未打印</span>
                        <span v-if="scope.row.expressPrintStatus==1">已打印</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="发货单状态" width="100" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.shippingPrintStatus==0" style="color:#f63b3b;">未打印</span>
                        <span v-if="scope.row.shippingPrintStatus==1">已打印</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="watchOrderDetail(scope.row)" size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 多选操作 -->
            <div style="margin-top: 20px">
                <span class="notice" v-if="choosedItem.length">
                    已经选择
                    <i>{{choosedItem.length}}</i> 项
                </span>
                <el-button type="primary" @click="batchAuditOrder">批量审核订单</el-button>
                <el-button type="primary" @click="markupException">批量标记异常</el-button>
                <el-button type="primary" @click="returnNormal">批量转正常</el-button>
                <el-button type="danger" @click="closeOrder">批量关闭订单</el-button>
                <!-- <el-button type="success" @click="ERPSync"><i class="el-icon-refresh"></i> ERP同步</el-button> -->
            </div>
            <!--分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[25, 50, 75, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>

        <!-- 高级搜索dialog框 -->
        <el-dialog title="高级搜索" class="searchDialog" :visible.sync="searchDialog" width="70%">
            <el-form :model="serachForm" class="signUp_Form" label-width="125px">
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="单号">
                            <el-input
                                v-model="serachForm.orderCode"
                                placeholder="请输入订单编号"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="收货人">
                            <el-input
                                v-model="serachForm.customer"
                                placeholder="请输入收货人名称"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="提交订单时间">
                            <el-date-picker
                                v-model="submitTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="商品名称">
                            <el-input
                                v-model="serachForm.title"
                                placeholder="请输入商品名称"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="制单人">
                            <el-input
                                v-model="serachForm.orderPerson"
                                placeholder="请输入制单人"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="订单备注">
                            <el-input
                                v-model="serachForm.remark"
                                placeholder="请输入订单备注"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="10">
                        <el-form-item label="所属业务员">
                            <el-select v-model="serachForm.salesman" placeholder="请选择商品标签">
                                <el-option label="全部" :value="0"></el-option>
                                <el-option
                                    v-for="item in salesmanList"
                                    :key="item.userId"
                                    :label="item.realName"
                                    :value="item.userId"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <el-row class="row">
                    <el-col :span="20">
                        <el-form-item label="单据状态">
                            <el-checkbox-group v-model="serachForm.orderStatus">
                                <el-checkbox :label="3">待审核</el-checkbox>
                                <el-checkbox :label="4">配货中</el-checkbox>
                                <el-checkbox :label="5">异常</el-checkbox>
                                <el-checkbox :label="8">待收货</el-checkbox>
                                <el-checkbox :label="10">已完成</el-checkbox>
                                <el-checkbox :label="14">已关闭</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="10">
                        <el-form-item label="财务状态">
                            <el-radio-group v-model="serachForm.payStatus">
                                <el-radio :label="null">全部</el-radio>
                                <el-radio :label="1">已付款</el-radio>
                                <el-radio :label="0">未付款</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col class="sale" :span="10">
                        <el-form-item label="下单方式">
                            <el-radio-group v-model="serachForm.agent">
                                <el-radio :label="0">自主下单</el-radio>
                                <el-radio :label="1">代客下单</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col> -->
                </el-row>
            </el-form>
            <div class="searchDialogBtn">
                <el-button @click="clearSerachForm">清空</el-button>
                <el-button class="dialogConfirmBtn" @click="searchDialogConfirm" type="primary">确认</el-button>
            </div>
        </el-dialog>

        <!-- 批量审核订单dialog框 -->
        <!-- <el-dialog title="批量审核订单" class="auditDialog" :visible.sync="setVerifyDialog" width="30%">
            <el-form :model="auditForm" class="signUp_Form" label-width="125px">
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="审核状态：" :rules="[{'required':true}]">
                            <el-switch
                                v-model="auditForm.audit"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="审核"
                                inactive-text="待审核"
                            ></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="备注：" :rules="[{'required':true}]">
                            <el-input
                                type="textarea"
                                maxlength="100"
                                placeholder="请输入备注，备注内容不能超过100个字"
                                :autosize="{minRows: 6 }"
                                clearable
                                v-model="auditForm.remark"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="btnBox">
                    <el-button @click="cancelBtn">取消</el-button>
                    <el-button @click="confirmAudit" type="primary">确认</el-button>
                </div>
            </el-form>
        </el-dialog>-->
        <!-- 批量通用标记dialog框 -->
        <el-dialog :title="commonDialogTitle" :visible.sync="commonRemarkDialog" width="30%">
            <el-form :model="commonDialogForm" class="signUp_Form" label-width="125px">
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="备注：" :rules="[{'required':true}]">
                            <el-input
                                type="textarea"
                                maxlength="100"
                                placeholder="请输入备注，备注内容不能超过100个字"
                                :autosize="{minRows: 6 }"
                                clearable
                                v-model="commonDialogForm.remark"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="btnBox" style="text-align:center;">
                    <el-button @click="cancelBtn">取消</el-button>
                    <el-button @click="commonDialogConfirm" type="primary">确认</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      baseUrl: this.$store.state.apiUrl,
      loading: true,
      orderStatus: this.$route.query.status ? this.$route.query.status : 0,
      totalCount: 0, //总数据条数
      maxResultCount: 25, //默认一页显示的个数,
      currentPage: 1,
      orderList: [], //商品列表主数据
      searchDialog: false, //高级搜索弹框显示是否
      submitTime: [],
      duration: [],
      printStatus: 0,
      salesmanList: [], //业务员列表
      serachForm: {
        //高级搜索弹框数据
        keyword: "",
        status: null,
        orderCode: null,
        customer: "",
        startTime: "",
        endTime: "",
        title: "",
        orderPerson: "",
        salesman: 0,
        remark: "",
        orderStatus: [],
        payStatus: null,
        agent: null,
        printStatus: 0
      },
      sorteHouseDialog: false, //是否显示库存详情弹框
      currentCheckItemID: 0, //当前准备设置标签的itemID
      choosedItem: [], //已选择的商品列表
      setVerifyDialog: false, //批量审核订单弹框
      auditForm: {
        audit: 0,
        remark: ""
      }, //审核表单
      commonDialogTitle: "",
      commonRemarkDialog: false, //标记公共dialog框
      commonDialogForm: {
        remark: ""
      },
      currentUri: "" //批量操作api
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    this.getDatas({
      MaxResultCount: this.maxResultCount,
      Status: this.orderStatus,
      orderStatus: []
    });
    this.getSalesmanList();
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/home") {
      sessionStorage.setItem("reload", true);
    } else {
      sessionStorage.setItem("reload", false);
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    let reload = sessionStorage.getItem("reload");
    if (reload) {
      sessionStorage.setItem("routerStatus", from.query.status);
    } else {
      sessionStorage.removeItem("routerStatus");
    }
    next();
  },
  activated() {
    let reload = sessionStorage.getItem("reload");
    let status = sessionStorage.getItem("routerStatus");

    if (reload && this.$route.query.status) {
      let params = {
        keyword: "",
        status: Number(this.$route.query.status) || 0,
        orderCode: null,
        customer: "",
        startTime: "",
        endTime: "",
        title: "",
        orderPerson: "",
        salesman: 0,
        remark: "",
        orderStatus: [],
        payStatus: null,
        agent: null,
        printStatus: 0,
        MaxResultCount: this.maxResultCount
      };
      this.serachForm = params;
      this.getDatas(params);
      this.currentPage = 1;
    }
  },
  methods: {
    // 根据时间搜索
    durationChange(val) {
      if (!val) {
        val = [];
      }
      this.serachForm.startTime = val[0];
      this.serachForm.endTime = val[1];
      this.getDatas({
        MaxResultCount: this.maxResultCount,
        Status: this.serachForm.status,
        orderStatus: [],
        printStatus: this.serachForm.printStatus,
        startTime: val[0],
        endTime: val[1]
      });
    },
    // 根据打印状态搜索
    printStatusChange(val) {
      this.serachForm.printStatus = val;
      this.getDatas({
        MaxResultCount: this.maxResultCount,
        Status: this.serachForm.status,
        orderStatus: [],
        printStatus: val,
        startTime: this.serachForm.startTime,
        endTime: this.serachForm.endTime
      });
    },
    //获取列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminOrder/PostOrderList",
        data: params,
        success(res) {
          self.orderList = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //获取业务员列表
    getSalesmanList() {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminSalesman/GetList",
        params: {
          MaxResultCount: 999
        },
        success(res) {
          self.salesmanList = res.items;
        },
        fail(res) {}
      });
    },
    //名字 编号等搜索
    serachIt() {
      this.getDatas({
        MaxResultCount: this.maxResultCount,
        Status: 0,
        keyword: this.serachForm.keyword,
        orderStatus: []
      });
      this.serachForm.status = 0;
      this.currentPage = 1;
    },
    //订单状态下拉快速搜索
    fastOrderStatusSearch(status) {
      this.serachForm.status = status;
      this.getDatas({
        MaxResultCount: this.maxResultCount,
        Status: status,
        orderStatus: [],
        printStatus: this.serachForm.printStatus,
        startTime: this.serachForm.startTime,
        endTime: this.serachForm.endTime
      });
      this.serachForm.keyword = "";
      this.currentPage = 1;
    },
    //高级搜索dialog弹框
    advancedSearch() {
      this.searchDialog = true;
    },
    //清空高级搜索数据
    clearSerachForm() {
      this.submitTime = [];
      this.serachForm = {
        //高级搜索弹框数据
        keyword: "",
        status: null,
        orderCode: null,
        customer: "",
        startTime: "",
        endTime: "",
        title: "",
        orderPerson: "",
        salesman: 0,
        remark: "",
        orderStatus: [],
        payStatus: null,
        agent: null,
        printStatus: 0
      };
    },
    //高级搜索确认
    searchDialogConfirm() {
      let params = this.serachForm;
      if (this.submitTime.length) {
        let startTime = this.submitTime[0];
        let endTime = this.submitTime[1];
        params.startTime = startTime;
        params.endTime = endTime;
      }
      params.MaxResultCount = this.maxResultCount;
      this.searchDialog = false;
      this.getDatas(params);
      this.currentPage = 1;
    },
    //查看订单
    watchOrderDetail(row) {
      this.$router.push({
        path: "/orderDetail",
        query: {
          orderCode: row.orderCode
        }
      });
    },
    //勾选单个表格
    handleSelectionChange(val) {
      this.choosedItem = val;
    },
    //批量审核订单点击
    batchAuditOrder() {
      let self = this;
      if (this.choosedItem.length) {
        for (let index = 0; index < self.choosedItem.length; index++) {
          debugger;
          const element = self.choosedItem[index];
          if (element.orderStatus!=3) {
            this.$message.error("不是待审核订单无法审核");
                return;
          }
        }

        this.$confirm("确认批量审核已勾选的订单吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let orderIDArr = [];
            self.choosedItem.forEach((ele, index) => {
              orderIDArr.push(ele.orderID);
            });
            $http.POST({
              url:
                this.$store.state.apiUrl +
                "/api/services/app/AdminOrder/AuditOrderVol",
              data: {
                orderID: orderIDArr
              },
              success(res) {
                self.$message({
                  type: "success",
                  message: `已审核！`
                });
                self.clearSerachForm();
                self.getDatas({
                  MaxResultCount: self.maxResultCount,
                  Status: 0,
                  orderStatus: []
                });
                self.currentPage = 1;
                self.$forceUpdate();
              },
              fail(res) {}
            });
          })
          .catch(() => {});
      } else {
        this.$message.error("请先勾选要审核的订单！");
        return;
      }
    },
    //取消按钮
    cancelBtn() {
      this.setVerifyDialog = false;
      this.commonRemarkDialog = false;
    },
    //批量审核订单确定
    confirmAudit() {
      let self = this;
      if (!this.auditForm.audit) {
        this.$message.error("请将滑块移到审核状态！");
        return;
      }
      if (!this.auditForm.remark) {
        this.$message.error("请填写备注");
        return;
      }
      this.setVerifyDialog = false;
      let orderIDArr = [];
      self.choosedItem.forEach((ele, index) => {
        orderIDArr.push(ele.orderID);
      });
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminOrder/AuditOrderVol",
        data: {
          orderID: orderIDArr,
          audit: this.auditForm.audit,
          remark: this.auditForm.remark
        },
        success(res) {
          self.$message({
            type: "success",
            message: `已审核！`
          });
          self.clearSerachForm();
          self.getDatas({
            MaxResultCount: self.maxResultCount,
            Status: 0,
            orderStatus: []
          });
          self.currentPage = 1;
          self.$forceUpdate();
        },
        fail(res) {}
      });
    },
    //批量标记异常
    markupException() {
      let self = this;
      if (this.choosedItem.length) {
        this.$confirm("确认批量标记异常已勾选的订单吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let orderIDArr = [];
            self.choosedItem.forEach((ele, index) => {
              orderIDArr.push(ele.orderID);
            });
            $http.POST({
              url:
                this.$store.state.apiUrl +
                "/api/services/app/AdminOrder/AuditFailOrderVol",
              data: {
                orderID: orderIDArr
              },
              success(res) {
                self.$message({
                  type: "success",
                  message: `已标记！`
                });
                self.clearSerachForm();
                self.getDatas({
                  MaxResultCount: self.maxResultCount,
                  Status: 0,
                  orderStatus: []
                });
                self.currentPage = 1;
                self.$forceUpdate();
              },
              fail(res) {}
            });
          })
          .catch(() => {});
      } else {
        this.$message.error("请先勾选要标记的订单！");
        return;
      }
    },
    //批量转正常
    returnNormal() {
      if (this.choosedItem.length) {
        this.commonDialogTitle = "批量转正常";
        this.currentUri = "ReAuditOrderVol";
        this.commonRemarkDialog = true;
      } else {
        this.$message.error("请先勾选要标记的订单！");
        return;
      }
    },
    //批量关闭订单
    closeOrder() {
      if (this.choosedItem.length) {
        this.commonDialogTitle = "批量关闭订单";
        this.currentUri = "CloseOrderVol";
        this.commonRemarkDialog = true;
      } else {
        this.$message.error("请先勾选要标记的订单！");
        return;
      }
    },
    //批量填写备注dialog框
    commonDialogConfirm() {
      let self = this;
      if (!this.commonDialogForm.remark) {
        this.$message.error("请填写备注");
        return;
      }
      this.commonRemarkDialog = false;
      let orderIDArr = [];
      self.choosedItem.forEach((ele, index) => {
        orderIDArr.push(ele.orderID);
      });
      let url =
        this.$store.state.apiUrl +
        "/api/services/app/AdminOrder/" +
        this.currentUri;
      $http.POST({
        url: url,
        data: {
          orderID: orderIDArr,
          remark: this.commonDialogForm.remark
        },
        success(res) {
          self.$message({
            type: "success",
            message: `操作成功！`
          });
          self.clearSerachForm();
          self.getDatas({
            MaxResultCount: self.maxResultCount,
            Status: 0,
            orderStatus: []
          });
          self.currentPage = 1;
          self.$forceUpdate();
        },
        fail(res) {}
      });
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val,
        Status: this.orderStatus,
        orderStatus: []
      };
      this.getDatas(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = this.serachForm;
      if (this.submitTime.length) {
        let startTime = this.submitTime[0];
        let endTime = this.submitTime[1];
        params.startTime = startTime;
        params.endTime = endTime;
      }
      params.MaxResultCount = this.maxResultCount;
      params.SkipCount = skipCount;
      this.getDatas(params);
    },
    //ERP同步
    ERPSync() {
      let self = this;
      let orderIDArr = [];
      self.choosedItem.forEach((ele, index) => {
        orderIDArr.push(ele.orderID);
      });
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminErp/SyncOrderToErp",
        data: orderIDArr,
        success(res) {
          let result = res.data;

          if (result != null && result.length > 0) {
            result.forEach(function(sorder) {
              if (sorder.syncStatus != 2) {
                self.orderList.forEach(function(o) {
                  if (o.orderCode === sorder.orderCode) {
                    o.isSyncToErp = 1;
                  }
                });
              }
            });

            for (let i = 0; i < result.length; i++) {
              const item = result[i];
              if (item.syncStatus == 2) {
                self.$message.error(item.msg);
                return;
              }
            }
          }
          self.$message({
            type: "success",
            message: `操作成功！`
          });
        },
        fail(res) {}
      });
    }
  }
};
</script>

<style lang='scss' scoped>
// 搜索栏
.searchBox {
  padding: 20px;
}
// 数据表格
.dataTable {
  padding-bottom: 0;
  margin: 20px;
  .tableBox {
    border: 1px solid #c5c5c5;
  }
  .orderCode {
    margin-left: 10px;
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
  }
  .goodBaseInfo {
    display: flex;
    align-items: center;
    .txtInfo {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      text-align: left;
      .title {
        font-size: 12px;
        color: #333;
      }
      .itemCode {
        font-size: 10px;
        color: #999;
      }
      .tags {
        display: flex;
        align-items: center;
        span {
          height: 18px;
          line-height: 18px;
          font-style: normal;
          font-size: 10px;
          padding: 0px 8px;
          color: #fff;
          background: #999;
          border-radius: 4px;
          margin-right: 4px;
        }
        /deep/ .el-popover__reference {
          cursor: pointer;
          margin: 0;
          padding: 0;
        }
      }
    }
    img {
      width: 100px;
      height: 100px;
      margin-right: 10px;
    }
  }
  .notice {
    display: inline-block;
    margin-right: 20px;
    i {
      font-style: normal;
      color: #f63b3b;
    }
  }
}
//高级搜索Dialog框
.searchDialog {
  .sale {
    display: flex;
    align-items: center;
    span {
      display: block;
      width: 125px;
      text-align: right;
      box-sizing: border-box;
      padding-right: 12px;
    }
    input {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100px;
      height: 32px;
      outline: #409eff;
      appearance: normal;
    }
  }
  .searchDialogBtn {
    text-align: center;
  }
}
//批量审核dialog框
.auditDialog {
  .btnBox {
    text-align: center;
  }
}
</style>
<style lang="scss">
.goodsListCheckBox {
  display: flex;
  flex-direction: column;
  label {
    margin-left: 0 !important;
  }
}
</style>
